<form [formGroup]="projectForm" (ngSubmit)="onSubmit()">
  <div class="form-row form-row--two-columns">
    <app-input
      [label]="'profile.project.title' | transloco"
      formControlName="title"
      [errorMessage]="
        projectForm.get('title')?.invalid && projectForm.get('title')?.touched ?
        (projectForm.get('title')?.errors?.['required'] ?
        ('validation.required.field' | transloco) :
        projectForm.get('title')?.errors?.['maxlength'] ?
        ('validation.maxLength.field' | transloco: {max: VALIDATION.TITLE_MAX_LENGTH}) :
        '') : ''
      "
      [required]="true"></app-input>
    <app-input
      [label]="'profile.project.position' | transloco"
      formControlName="position"
      [errorMessage]="
        projectForm.get('position')?.invalid && projectForm.get('position')?.touched ?
        (projectForm.get('position')?.errors?.['required'] ?
        ('validation.required.position' | transloco) :
        projectForm.get('position')?.errors?.['maxlength'] ?
        ('validation.maxLength.position' | transloco: {max: VALIDATION.POSITION_MAX_LENGTH}) :
        '') : ''
      "
      [required]="true"></app-input>
  </div>

  <div class="form-row form-row--two-columns">
    <app-input
      [label]="'profile.project.duration' | transloco"
      formControlName="duration"
      type="number"
      [errorMessage]="
        projectForm.get('duration')?.invalid && projectForm.get('duration')?.touched ?
        (projectForm.get('duration')?.errors?.['required'] ?
        ('validation.required.field' | transloco) :
        projectForm.get('duration')?.errors?.['min'] ?
        ('validation.invalid.number' | transloco) :
        '') : ''
      "
      [required]="true"
      [min]="0"></app-input>
    <app-input
      [label]="'profile.project.country' | transloco"
      formControlName="country"
      [errorMessage]="
        projectForm.get('country')?.invalid && projectForm.get('country')?.touched ?
        ('validation.maxLength.country' | transloco: {max: VALIDATION.COUNTRY_MAX_LENGTH}) : ''
      "></app-input>
  </div>

  <div class="form-actions">
    <app-button type="button" variant="outline" color="secondary" (click)="cancel.emit()">
      {{ 'button.cancel' | transloco }}
    </app-button>
    <app-button type="submit" variant="filled" [disabled]="projectForm.invalid">
      {{ 'button.save' | transloco }}
    </app-button>
  </div>
</form>
